module.exports = __webpack_public_path__ + "img/dragon_turtle_small.b555e083.png";